"use strict";


module.exports = {
	is_name_valid: function (name) {
		return name && name.length > 0;
	},

	name_error: "Please enter your name."
};